module.exports = __webpack_public_path__ + "static/media/sense-light.37d6b335.png";